@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.kyc.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.kyc.generated.resources/"

internal val Res.string.feature_kyc_address_line_1: StringResource by lazy {
      StringResource("string:feature_kyc_address_line_1", "feature_kyc_address_line_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 54),
      ))
    }

internal val Res.string.feature_kyc_address_line_2: StringResource by lazy {
      StringResource("string:feature_kyc_address_line_2", "feature_kyc_address_line_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65, 54),
      ))
    }

internal val Res.string.feature_kyc_approve: StringResource by lazy {
      StringResource("string:feature_kyc_approve", "feature_kyc_approve", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207, 39),
      ))
    }

internal val Res.string.feature_kyc_approve_permission: StringResource by lazy {
      StringResource("string:feature_kyc_approve_permission", "feature_kyc_approve_permission", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120, 86),
      ))
    }

internal val Res.string.feature_kyc_browse: StringResource by lazy {
      StringResource("string:feature_kyc_browse", "feature_kyc_browse", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247, 34),
      ))
    }

internal val Res.string.feature_kyc_check: StringResource by lazy {
      StringResource("string:feature_kyc_check", "feature_kyc_check", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 282, 37),
      ))
    }

internal val Res.string.feature_kyc_complete_kyc: StringResource by lazy {
      StringResource("string:feature_kyc_complete_kyc", "feature_kyc_complete_kyc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320, 64),
      ))
    }

internal val Res.string.feature_kyc_completion: StringResource by lazy {
      StringResource("string:feature_kyc_completion", "feature_kyc_completion", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 385, 42),
      ))
    }

internal val Res.string.feature_kyc_content_description_placeholder: StringResource by lazy {
      StringResource("string:feature_kyc_content_description_placeholder", "feature_kyc_content_description_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 428, 67),
      ))
    }

internal val Res.string.feature_kyc_date_format: StringResource by lazy {
      StringResource("string:feature_kyc_date_format", "feature_kyc_date_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 496, 47),
      ))
    }

internal val Res.string.feature_kyc_error_adding_KYC_Level_1_details: StringResource by lazy {
      StringResource("string:feature_kyc_error_adding_KYC_Level_1_details", "feature_kyc_error_adding_KYC_Level_1_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 544, 96),
      ))
    }

internal val Res.string.feature_kyc_error_adding_KYC_Level_2_details: StringResource by lazy {
      StringResource("string:feature_kyc_error_adding_KYC_Level_2_details", "feature_kyc_error_adding_KYC_Level_2_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 641, 96),
      ))
    }

internal val Res.string.feature_kyc_error_kyc_details: StringResource by lazy {
      StringResource("string:feature_kyc_error_kyc_details", "feature_kyc_error_kyc_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 738, 101),
      ))
    }

internal val Res.string.feature_kyc_error_oops: StringResource by lazy {
      StringResource("string:feature_kyc_error_oops", "feature_kyc_error_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 840, 38),
      ))
    }

internal val Res.string.feature_kyc_file_name: StringResource by lazy {
      StringResource("string:feature_kyc_file_name", "feature_kyc_file_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 879, 45),
      ))
    }

internal val Res.string.feature_kyc_first_name: StringResource by lazy {
      StringResource("string:feature_kyc_first_name", "feature_kyc_first_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 925, 46),
      ))
    }

internal val Res.string.feature_kyc_id_type: StringResource by lazy {
      StringResource("string:feature_kyc_id_type", "feature_kyc_id_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 972, 39),
      ))
    }

internal val Res.string.feature_kyc_last_name: StringResource by lazy {
      StringResource("string:feature_kyc_last_name", "feature_kyc_last_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1012, 41),
      ))
    }

internal val Res.string.feature_kyc_level: StringResource by lazy {
      StringResource("string:feature_kyc_level", "feature_kyc_level", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1174, 33),
      ))
    }

internal val Res.string.feature_kyc_level_1: StringResource by lazy {
      StringResource("string:feature_kyc_level_1", "feature_kyc_level_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1054, 39),
      ))
    }

internal val Res.string.feature_kyc_level_2: StringResource by lazy {
      StringResource("string:feature_kyc_level_2", "feature_kyc_level_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1094, 39),
      ))
    }

internal val Res.string.feature_kyc_level_3: StringResource by lazy {
      StringResource("string:feature_kyc_level_3", "feature_kyc_level_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1134, 39),
      ))
    }

internal val Res.string.feature_kyc_loading: StringResource by lazy {
      StringResource("string:feature_kyc_loading", "feature_kyc_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1208, 39),
      ))
    }

internal val Res.string.feature_kyc_pan_id: StringResource by lazy {
      StringResource("string:feature_kyc_pan_id", "feature_kyc_pan_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1248, 34),
      ))
    }

internal val Res.string.feature_kyc_phone_number: StringResource by lazy {
      StringResource("string:feature_kyc_phone_number", "feature_kyc_phone_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1283, 48),
      ))
    }

internal val Res.string.feature_kyc_select_dob: StringResource by lazy {
      StringResource("string:feature_kyc_select_dob", "feature_kyc_select_dob", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1332, 50),
      ))
    }

internal val Res.string.feature_kyc_submit: StringResource by lazy {
      StringResource("string:feature_kyc_submit", "feature_kyc_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1430, 34),
      ))
    }

internal val Res.string.feature_kyc_submitting: StringResource by lazy {
      StringResource("string:feature_kyc_submitting", "feature_kyc_submitting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1383, 46),
      ))
    }

internal val Res.string.feature_kyc_successkyc1: StringResource by lazy {
      StringResource("string:feature_kyc_successkyc1", "feature_kyc_successkyc1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1465, 67),
      ))
    }

internal val Res.string.feature_kyc_successkyc2: StringResource by lazy {
      StringResource("string:feature_kyc_successkyc2", "feature_kyc_successkyc2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1533, 67),
      ))
    }

internal val Res.string.feature_kyc_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_kyc_unexpected_error_subtitle", "feature_kyc_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1601, 109),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_kyc_address_line_1", Res.string.feature_kyc_address_line_1)
  map.put("feature_kyc_address_line_2", Res.string.feature_kyc_address_line_2)
  map.put("feature_kyc_approve", Res.string.feature_kyc_approve)
  map.put("feature_kyc_approve_permission", Res.string.feature_kyc_approve_permission)
  map.put("feature_kyc_browse", Res.string.feature_kyc_browse)
  map.put("feature_kyc_check", Res.string.feature_kyc_check)
  map.put("feature_kyc_complete_kyc", Res.string.feature_kyc_complete_kyc)
  map.put("feature_kyc_completion", Res.string.feature_kyc_completion)
  map.put("feature_kyc_content_description_placeholder", Res.string.feature_kyc_content_description_placeholder)
  map.put("feature_kyc_date_format", Res.string.feature_kyc_date_format)
  map.put("feature_kyc_error_adding_KYC_Level_1_details", Res.string.feature_kyc_error_adding_KYC_Level_1_details)
  map.put("feature_kyc_error_adding_KYC_Level_2_details", Res.string.feature_kyc_error_adding_KYC_Level_2_details)
  map.put("feature_kyc_error_kyc_details", Res.string.feature_kyc_error_kyc_details)
  map.put("feature_kyc_error_oops", Res.string.feature_kyc_error_oops)
  map.put("feature_kyc_file_name", Res.string.feature_kyc_file_name)
  map.put("feature_kyc_first_name", Res.string.feature_kyc_first_name)
  map.put("feature_kyc_id_type", Res.string.feature_kyc_id_type)
  map.put("feature_kyc_last_name", Res.string.feature_kyc_last_name)
  map.put("feature_kyc_level", Res.string.feature_kyc_level)
  map.put("feature_kyc_level_1", Res.string.feature_kyc_level_1)
  map.put("feature_kyc_level_2", Res.string.feature_kyc_level_2)
  map.put("feature_kyc_level_3", Res.string.feature_kyc_level_3)
  map.put("feature_kyc_loading", Res.string.feature_kyc_loading)
  map.put("feature_kyc_pan_id", Res.string.feature_kyc_pan_id)
  map.put("feature_kyc_phone_number", Res.string.feature_kyc_phone_number)
  map.put("feature_kyc_select_dob", Res.string.feature_kyc_select_dob)
  map.put("feature_kyc_submit", Res.string.feature_kyc_submit)
  map.put("feature_kyc_submitting", Res.string.feature_kyc_submitting)
  map.put("feature_kyc_successkyc1", Res.string.feature_kyc_successkyc1)
  map.put("feature_kyc_successkyc2", Res.string.feature_kyc_successkyc2)
  map.put("feature_kyc_unexpected_error_subtitle", Res.string.feature_kyc_unexpected_error_subtitle)
}
